module.exports = __webpack_public_path__ + "static/img/result_none.5ae8132b.png";